import gql from 'graphql-tag';

export const listChargesQuery = gql(/* GraphQL */ `
  query listCharges($listChargesRequest: ListChargesRequest!) {
    accounts {
      listCharges(listChargesRequest: $listChargesRequest) {
        charges {
          id
          name
          description
          amount
          status
          externalPayerId
          currency
          createdAt
          updatedAt
          invoiceId
          invoice {
            id
            invoiceDisplayId
            status
            invoiceDate
            dueDate
          }
          items {
            product {
              id
              name
              description
              productCategory {
                productCategoryId
                name
                description
                productType
              }
              amount
              markup {
                value
                markupAmountType
              }
              tax {
                value
                taxAmountType
              }
              originalPrice {
                amount
                markup {
                  value
                  markupAmountType
                }
                tax {
                  value
                  taxAmountType
                }
              }
              sellingPrice {
                grossMarkup
                grossTax
                listPrice
                netPrice
                grossAdminFee
                grossAdminFeeTax
              }
            }
            quantity
            isRateOverridden
          }
        }
        pageInfo {
          perPage
          total
          start
        }
      }
    }
  }
`);
